(() => {
    const init = (root) => {
      root.querySelectorAll('[data-product-summary-material]').forEach((material) => {
        if (material.dataset.materialInitialized === 'true') return;
        const section = material.closest('[data-product-section], [data-moonlit-product-section]');
        if (!section) return;
        material.dataset.materialInitialized = 'true';
        const variants = JSON.parse(material.dataset.materialVariants);
        let renderedText;
        const render = (text) => {
          if (text === renderedText) return;
          renderedText = text;
          const lines = text.split('|').filter(Boolean);
          material.replaceChildren(...lines.map((line) => {
            const span = document.createElement('span');
            span.textContent = line;
            return span;
          }));
        };
        const update = (id) => render(variants.find((variant) => variant.id === String(id))?.material || material.dataset.defaultMaterial);
        const slides = [...section.querySelectorAll('[data-product-gallery-slide]')];
        const mediaMaterials = new Map(slides.map((slide) => {
          const mediaId = slide.dataset.mediaId;
          let variant = variants.find((item) => item.mediaId && item.mediaId === mediaId);
          if (!variant) {
            const alt = slide.querySelector('img')?.alt || '';
            const sku = /^Gold Cove Earrings\b/i.test(alt) ? 'YEL-479' : /^Silver Cove Earrings\b/i.test(alt) ? 'YEL-480' : null;
            if (sku) variant = variants.find((item) => item.sku === sku);
          }
          return [mediaId, variant?.material || material.dataset.defaultMaterial];
        }));
        const updateForMedia = (mediaId) => render(mediaMaterials.get(mediaId) || material.dataset.defaultMaterial);
        section.addEventListener('product:gallery-change', (event) => updateForMedia(event.detail?.targetMediaId || event.detail?.mediaId));
        section.addEventListener('change', (event) => {
          if (event.target instanceof Element && event.target.matches('.product-select')) update(event.target.value);
        });
        section.addEventListener('moonlit:variant-change', (event) => update(event.detail?.id));
        const gallery = section.querySelector('[data-product-gallery]');
        if (gallery?.dataset.activeMediaId) updateForMedia(gallery.dataset.activeMediaId);
      });
    };
    init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('mia:page:mount', (event) => init(event.detail.root));
  })();
